import {
    BEGIN_AJAX_CALL,
    END_AJAX_CALL,
    LAYOUT_SIDEBAR,
    SET_CURRENT_USERS_TAB,
    SET_CURRENT_USER_EDIT_TAB,
    SET_CURRENT_CONFIGURATION_TAB,
    SET_CURRENT_BLOCKS_TAB,
    SET_CURRENT_TRANSLATION_EDIT_TABS,
    SET_CURRENT_LABELS_TAB,
    SET_CURRENT_STAFF_TAB,
    SET_CURRENT_TAGS_TAB,
    SET_CURRENT_FAQS_TAB,
    SET_CURRENT_PAGES_TAB,
    SET_CURRENT_TEMPLATES_TAB,
    SET_UPLOAD_PROGRESS
} from './types';
import update from 'immutability-helper';

const INITIAL_STATE = {
    sidebarOpen: false,
    ajaxCallsInProgress: 0,
    activeUsersTab: 0,
    activeBlocksTab: {},
    activeTranslationEditTabs: {},
    activeUsersEditTab: {},
    activeConfigurationTab: 0,
    activeLabelsTab: {},
    activeStaffTab: {},
    activeTagsTab: {},
    activeFaqsTab: {},
    activePagesTab: {},
    activeTemplatesTab: {},
    progressPercent: null,
};

export default function(state = INITIAL_STATE, action) {

    switch(action.type) {
        case LAYOUT_SIDEBAR:

            return update(state, {
                sidebarOpen: {
                    $set: action.payload
                }
            });

        case BEGIN_AJAX_CALL:

            return update(state, {
                ajaxCallsInProgress: {
                    $apply: function(x) {
                        return x + 1;
                    }
                }
            });

        case END_AJAX_CALL:

            return update(state, {
                ajaxCallsInProgress: {
                    $apply: function(x) {
                        return x - 1;
                    }
                },
                progressPercent: {
                    $set: null
                }
            });
        
        case SET_UPLOAD_PROGRESS:

            return update(state, {
                progressPercent: {
                    $set: action.payload
                }
            });
        
        /** PAGES **/
        case SET_CURRENT_PAGES_TAB:

            return update(state, {
                activePagesTab: {
                    [action.payload.pageId] : {$set: action.payload.value }
                }
            });

        /** TEMPLATES **/
        case SET_CURRENT_TEMPLATES_TAB:

            return update(state, {
                activeTemplatesTab: {
                    [action.payload.templateId] : {$set: action.payload.value }
                }
            });

        /** USERS **/
        case SET_CURRENT_USERS_TAB:

            return update(state, {
                activeUsersTab: {
                    $set: action.payload
                }
            });

        case SET_CURRENT_USER_EDIT_TAB:

            return update(state, {
                activeUsersEditTab: {
                    [action.payload.userId] : {$set: action.payload.value }
                }
            });

        /** BLOCKS **/
        case SET_CURRENT_BLOCKS_TAB:

            return update(state, {
                activeBlocksTab: {
                    [action.payload.blockId] : {$set: action.payload.value }
                }
            });

        case SET_CURRENT_TRANSLATION_EDIT_TABS:

            return update(state, {
                activeTranslationEditTabs: {
                    [action.payload.blockId] : {$set: action.payload.value },
                }
            });


        /** CONFIGURATION **/
        case SET_CURRENT_CONFIGURATION_TAB:

            return update(state, {
                activeConfigurationTab: {
                    $set: action.payload
                }
            });

        /** LABELS **/
        case SET_CURRENT_LABELS_TAB:

            return update(state, {
                activeLabelsTab: {
                    [action.payload.labelId] : {$set: action.payload.value }
                }
            });

        /** STAFF **/
        case SET_CURRENT_STAFF_TAB:

            return update(state, {
                activeStaffTab: {
                    [action.payload.staffId]: {$set: action.payload.value }
                }
            });

        /** TAGS **/
        case SET_CURRENT_TAGS_TAB:

            return update(state, {
                activeTagsTab: {
                    [action.payload.tagId]: {$set: action.payload.value }
                }
            });

        /** FAQS **/
        case SET_CURRENT_FAQS_TAB:

            return update(state, {
                activeFaqsTab: {
                    [action.payload.faqId]: {$set: action.payload.value }
                }
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/layout/reducer.js